import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import PairLock from '../../../../components/rooms/PairLock'
import Page404 from '../../../../routes/404'

import { rooms as ROLES_CONFIG } from '../../../../config/roles';


export default class LockPair extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role: this.props.authenticated ? this.props.authenticated.role : null,
            _id: this.props && this.props.match && this.props.match.params ? this.props.match.params.id : ''
        }
    }

    render() {
        return (
            <div id="content">
                <div className="row">
                    {
                        ROLES_CONFIG.pairLock.indexOf(this.state.role) != -1 ?
                            <Paper className="col-md-11 ml-2vw h-100 mt-1vw p-0 customShadow" zDepth={3}>
                                {
                                    this.state._id && this.state._id.split('_')[0] && this.state._id.split('_')[1] ? <PairLock lock_id={this.state._id.split('_')[0]} room_id={this.state._id.split('_')[1]} /> : <Page404 />
                                }
                            </Paper>
                            : null
                    }
                </div>
            </div>
        )
    }
} 


// WEBPACK FOOTER //
// ./routes/app/routes/rooms/LockPair.js